import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'

type Options = {
  title: string
  href: string
}

interface Props {
  legalName: string
  options: Options[]
}

const AccountMenu = ({ legalName, options }: Props) => {
  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Box flexDirection="row" alignItems="center">
          <Box textAlign="left">
            <Text.Normal color="grey000White" weight="semibold" size="200">
              {legalName}
            </Text.Normal>
          </Box>
          <Icon.Small icon="caret-down" />
        </Box>
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="top" align="center">
        <Box background="grey000White">
          {options.map(({ title, href }) => (
            <PopoverMenu.HrefOption key={title} title={title} href={href} />
          ))}
        </Box>
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default AccountMenu
